/**
 * 请注意，原有的 wx.onMenuShareTimeline、wx.onMenuShareAppMessage、wx.onMenuShareQQ、wx.onMenuShareQZone 接口，即将废弃。
 * 请尽快迁移使用客户端6.7.2及JSSDK 1.4.0以上版本支持的 wx.updateAppMessageShareData、wx.updateTimelineShareData接口
 */

export interface IWXShareCommonParams {
  title: string; // 分享标题
  imgUrl: string; // 分享图标
  link: string; // 分享链接（之后的链接），该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  desc?: string; // 分享描述
}

// 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
export type IWXUpdateTimelineShare = IWXShareCommonParams;

// 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
export type IWXMenuShareTimeline = IWXShareCommonParams;

/**
 * 分享功能
 */
enum shareAppMessageType {
  link = 'link',
  music = 'music',
  video = 'video',
}
// 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
export type IWXShareAppMessage = IWXShareCommonParams & {
  type: shareAppMessageType; // 分享类型,music、video或link，不填默认为link
  dataUrl: string; // 如果type是music或video，则要提供数据链接，默认为空
};

export enum jsApiListType {
  updateAppMessageShareData = 'updateAppMessageShareData',
  updateTimelineShareData = 'updateTimelineShareData',
  onMenuShareTimeline = 'onMenuShareTimeline',
  onMenuShareAppMessage = 'onMenuShareAppMessage',
  onMenuShareQQ = 'onMenuShareQQ',
  onMenuShareWeibo = 'onMenuShareWeibo',
  onMenuShareQZone = 'onMenuShareQZone',
  startRecord = 'startRecord',
  stopRecord = 'stopRecord',
  onVoiceRecordEnd = 'onVoiceRecordEnd',
  playVoice = 'playVoice',
  pauseVoice = 'pauseVoice',
  stopVoice = 'stopVoice',
  onVoicePlayEnd = 'onVoicePlayEnd',
  uploadVoice = 'uploadVoice',
  downloadVoice = 'downloadVoice',
  chooseImage = 'chooseImage',
  previewImage = 'previewImage',
  uploadImage = 'uploadImage',
  downloadImage = 'downloadImage',
  translateVoice = 'translateVoice',
  getNetworkType = 'getNetworkType',
  openLocation = 'openLocation',
  getLocation = 'getLocation',
  hideOptionMenu = 'hideOptionMenu',
  showOptionMenu = 'showOptionMenu',
  hideMenuItems = 'hideMenuItems',
  showMenuItems = 'showMenuItems',
  hideAllNonBaseMenuItem = 'hideAllNonBaseMenuItem',
  showAllNonBaseMenuItem = 'showAllNonBaseMenuItem',
  closeWindow = 'closeWindow',
  scanQRCode = 'scanQRCode',
  chooseWXPay = 'chooseWXPay',
  openProductSpecificView = 'openProductSpecificView',
  addCard = 'addCard',
  chooseCard = 'chooseCard',
  openCard = 'openCard',
}

export type IWXShareOptions = IWXUpdateTimelineShare & IWXMenuShareTimeline & IWXShareAppMessage;

export interface IWXShareRes {
  success: boolean;
  type: jsApiListType;
  message: string;
}
